import Prism from 'prismjs';
import 'prismjs/plugins/toolbar/prism-toolbar.js';
import 'prismjs/plugins/copy-to-clipboard/prism-copy-to-clipboard.js';

require('prismjs/components/prism-markup-templating');
require('prismjs/components/prism-json');
require('prismjs/components/prism-bash');
require('prismjs/components/prism-javascript');
require('prismjs/components/prism-ruby');
require('prismjs/components/prism-php');
require('prismjs/components/prism-go');
require('prismjs/components/prism-csharp');
require('prismjs/components/prism-python');
require('prismjs/components/prism-java');

let HTTPSnippet = require('httpsnippet');

let languages = [
    {
        name: 'shell',
        prism: Prism.languages.bash,
        options: {
            indent: false
        }
    },
    {
        name: 'node',
        prism: Prism.languages.javascript,
        options: {}
    },
    {
        name: 'python',
        prism: Prism.languages.python,
        options: {}
    },
    {
        name: 'php',
        prism: Prism.languages.php,
        options: {}
    },
    {
        name: 'go',
        prism: Prism.languages.go,
        options: {}
    },
    {
        name: 'java',
        prism: Prism.languages.java,
        options: {}
    },
    {
        name: 'csharp',
        prism: Prism.languages.csharp,
        options: {}
    },
    {
        name: 'ruby',
        prism: Prism.languages.ruby,
        options: {}
    },
];

let codeGenerators = document.querySelectorAll(".code-generator-component");

function generateParticularCode(codeGenerator, snippet, language) {
    let code = codeGenerator.querySelector("." + language.name);
    let codeSnippet = snippet.convert(language.name, language.options);
    if (language.name == "shell") {
        codeSnippet = codeSnippet.replaceAll("'", '"');
    }
    code.innerHTML = Prism.highlight(codeSnippet, language.prism);
}

function generateCode(codeGenerator) {
    let info = JSON.parse(codeGenerator.getAttribute("data-query"));
    
    if (info.url != null) {
        var snippet = new HTTPSnippet({
            method: info.method,
            url: info.url
        });
        languages.forEach(function (language) {
            generateParticularCode(codeGenerator, snippet, language);
        })
    }
}

for (let index = 0; index < codeGenerators.length; index++) {
    generateCode(codeGenerators[index]);
}